import { Group, Stack, Text } from "@mantine/core"
import { Card, Missing, CountryCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { EnrichedOperationDto } from "~/gen/api"
import { SUPPLIER_CARD_HEIGHT } from "~/pages/Brand/Products/Details/constants.ts"
import { COUNTRIES } from "~/utils/countries"
import { useGetOperations } from "~/utils/operations"

const SupplierCardDetails = ({
  organizationName,
  address,
}: {
  organizationName: string | undefined
  address: string | undefined
}) => {
  const { t } = useTranslation("products")

  return (
    <>
      <Group align="flex-start" justify="space-between" wrap="nowrap">
        <Text>{t("traceability.supplierCard.company")}:</Text>
        <Text fw={700} style={{ textAlign: "right" }}>
          {organizationName ?? <Missing />}
        </Text>
      </Group>
      <Group align="flex-start" justify="space-between" wrap="nowrap">
        <Text>{t("traceability.supplierCard.address")}:</Text>
        <Text style={{ textAlign: "right" }} fw={700}>
          {address || <Missing />}
        </Text>
      </Group>
    </>
  )
}

type SupplierCardProps = {
  activityName: string
  itemReference?: string
  operation?: EnrichedOperationDto
}

export const SupplierCard = ({
  activityName,
  itemReference,
  operation,
}: SupplierCardProps) => {
  const { t } = useTranslation("products")

  const operationInfo = useGetOperations()[activityName]

  return (
    <Card w={340} h={SUPPLIER_CARD_HEIGHT}>
      <Stack gap="xs">
        <Group justify="space-between" mb="xs" wrap="nowrap" align="flex-end">
          <Group gap="xs" wrap="nowrap">
            {operationInfo.icon && <operationInfo.icon />}
            <Text style={{ fontWeight: "bold" }}>{operationInfo.name}</Text>
          </Group>
          <CountryCell
            countryIso3166={operation?.country.value}
            countriesMapper={COUNTRIES}
          />
        </Group>
        <Group align="flex-start" justify="space-between" wrap="nowrap">
          <Text>{t("traceability.supplierCard.reference")}:</Text>
          <Text style={{ textAlign: "right" }} truncate fw={700}>
            {itemReference ?? <Missing />}
          </Text>
        </Group>

        <SupplierCardDetails
          organizationName={operation?.productionSite.value?.organizationName}
          address={operation?.productionSite.value?.address}
        />

        <Text />
      </Stack>
    </Card>
  )
}
